import { defineStore } from "pinia";

export const usePermissionsStore = defineStore("permissionsStore", {
  state: () => ({
    scopesAndPlans: [],
    allPermissions: [],
    allScopes: [],
    subscription: null,
    plans: null,
  }),
  actions: {
    setValue(keyValue) {
      if (keyValue?.key in this) {
        this[keyValue.key] = keyValue.value;
      }
    },
    setScopesAndPlans(scopesAndPlans) {
      this.scopesAndPlans = scopesAndPlans;
    },
    SET_VALUE(keyValue) {
      this.setValue(keyValue);
    },
    SET_SCOPES_AND_PLANS(scopesAndPlans) {
      this.setScopesAndPlans(scopesAndPlans);
    },
  },
});

export default usePermissionsStore;
